

















































import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable/useDeclination';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { InstitutionalPushModel } from '~/diptyqueTheme/types/contentful/contentTypes';

export default defineComponent({
  name: 'InstitutionalPushMobileDeclination1',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoBadge: () => import('atoms/VaimoBadge.vue'),
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoTruncatedText: () => import('atoms/VaimoTruncatedText.vue'),
    VaimoButton: () => import('atoms/VaimoButton.vue')
  },
  props: {
    declinationData: {
      required: true,
      type: Object as PropType<InstitutionalPushModel & MediaPreloadableSection>
    }
  },
  setup(props) {
    const { getBannerData, getCTAdata } = useDeclination(props.declinationData);

    return {
      getBannerData,
      getCTAdata
    };
  }
});
